import {Pipe, PipeTransform} from '@angular/core';
import {NestleStatus} from "@services";

@Pipe({
    name: 'nestleStatus',
    standalone: true
})
export class NestleStatusPipe implements PipeTransform {
    transform(value: NestleStatus | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case NestleStatus.SapPendingNestle: return "SAP Pending - Nestle";
            case NestleStatus.DwaPendingNestle: return "DWA Pending - Nestle";
            case NestleStatus.DwaPendingHopewell: return "DWA Pending - Hopewell";
            case NestleStatus.NextViewPendingHopewell: return "NextView Pending - Hopewell";
            case NestleStatus.Active: return "Active";
            case NestleStatus.TerminationPending: return "Termination Pending";
            case NestleStatus.Terminated: return "Terminated";
            case NestleStatus.DeactivationPending: return "Deactivation Pending";
            case NestleStatus.Inactive: return "Inactive";
            case NestleStatus.PasswordResetRequired: return "Password Reset Required";

            default: return value;
        }
    }
}
